import React, { useEffect, useState } from "react";
import {
  Cell,
  LabelList,
  Tooltip,
  Legend,
  BarChart,
  Bar,
  Pie,
  PieChart,
  CartesianGrid,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Brush,
} from "recharts";
import { useDispatch, useSelector } from "react-redux";
import { getFetchQulityRecode } from "../../Utils/actions";
import { Button, IconButton } from "@material-ui/core";
import RefreshIcon from "@mui/icons-material/Refresh";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import HouseIcon from "@mui/icons-material/House";
import { loadingOn } from "../../Utils/utils";
import { useNavigate } from "react-router-dom";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Switch } from "@material-ui/core";
import { Tooltip as ToolTipCore } from "@material-ui/core";

const DataQuality = ({
  toggleFullScreen,
  isFullScreen,
  logs,
  well,
  rigsId,
  allJobsData,
}) => {
  const { dataqualityChartData } = useSelector((state) => state.data);
  const [rigName, setRigName] = useState("");
  const [Json, setJson] = useState();
  const [DQGraph, setDQGraph] = useState(true);
  const [isInverted, setIsInverted] = useState(false);
  const dispatch = useDispatch();

  const legendData = [
    // { color: "#212C68", name: "Excellent" },
    { color: "#66b266", name: "Good" },
    { color: "#ffd96a", name: "Average" },
    { color: "#ff6666", name: "Bad" }, // { color: "red", name: "Not-acceptable" }
  ];

  // -    { color: "#212C68", name: "Excellent" },
  // -    { color: "#48578E", name: "Good" },
  // -    { color: "#46a2da", name: "Average" },
  // -    { color: "#296d98", name: "Bad" },
  // -    { color: "red", name: "Not-acceptable" } #0c3855 #5ca4d3 #10659d

  useEffect(() => {
    const fetchData = async () => {
      try {
        dispatch(loadingOn());
        await dispatch(
          getFetchQulityRecode({
            logs,
            well,
            rigsId,
            bunit: allJobsData.bunit,
            dataprovider: allJobsData.dataprovider,
            version: allJobsData.version,
          })
        );
      } catch (error) {
        console.error("Error fetching data quality records:", error);
      }
    };
    if (allJobsData) {
      fetchData();
    }
  }, [logs, well, rigsId, allJobsData]);

  const handleRefresh = () => {
    if (allJobsData) {
      dispatch(loadingOn());
      dispatch(
        getFetchQulityRecode({
          logs,
          well,
          rigsId,
          bunit: allJobsData.bunit,
          dataprovider: allJobsData.dataprovider,
          version: allJobsData.version,
        })
      );
    }
  };

  useEffect(() => {
    if (dataqualityChartData) {
      setJson(dataqualityChartData);
    }
  }, [dataqualityChartData]);

  useEffect(() => {
    return () => {
      setJson(null);
    };
  }, []);

  const randomData = dataqualityChartData
    ? Object.entries(dataqualityChartData)
        .map(([date, value]) => ({
          name: date,
          value: isInverted ? 100 - value : value,
        }))
        .filter((dataPoint) => dataPoint.value !== 0)
    : [];

  randomData.sort((a, b) => new Date(a.name) - new Date(b.name));

  let keys = [];
  if (dataqualityChartData) {
    keys = Object.keys(dataqualityChartData);
    if (keys.length > 0) {
      keys.sort((a, b) => new Date(a) - new Date(b));
    }
  }

  const startTime = keys.length > 0 ? keys[0] : null;
  const endTime = keys.length > 0 ? keys[keys.length - 1] : null;

  const renderColor = (value) => {
    // if (value < 20) {
    //   return "red";
    // } else if (value >= 20 && value < 50) {
    //   return "#296d98";
    // } else if (value >= 50 && value < 70) {
    //   return "#46a2da";
    // } else if (value >= 70 && value < 90) {
    //   return "#48578E";
    // } else {
    //   return "#212C68";
    // }

    // #0c3855 #5ca4d3 #10659d

    return isInverted
      ? // value <= 10 ? "#212C68" :
        value > 25 && value <= 100
        ? "#ff6666"
        : value > 5 && value <= 25
        ? "#ffd96a"
        : value >= 0 && value <= 5
        ? "#66b266"
        : null
      : // :
      //   value > 90 ? 'red' : null

      // value < 20 ? "red" :
      //   value >= 20 && value < 50 ? "#296d98" :
      value >= 0 && value < 75
      ? "#ff6666"
      : value >= 75 && value < 95
      ? "#ffd96a"
      : value >= 95
      ? "#66b266"
      : null;
  };

  //   { color: "#24db24", name: "Good" },
  // { color: "#ffb939", name: "Average" },
  // { color: "#ff5a5a", name: "Bad" },

  const legendDataPayload = legendData.map((entry) => ({
    value: entry.name,
    type: "square",
    color: entry.color,
  }));

  const CommonLegend = (
    <Legend
      layout="horizontal"
      payload={legendDataPayload}
      className="centerWrapperStyle"
    />
  );
  const navigate = useNavigate();
  const handleLogBar = (date) => {
    navigate("/dq", {
      state: {
        well,
        rigsId,
        DQGraph,
        dataprovider: allJobsData?.dataprovider,
        jobDate: date,
        logs,
        checkActiveAPI: true,
      },
    });
  };

  const data1 = [
    { name: "A", value: 10 },
    { name: "B", value: 15 },
    { name: "C", value: 20 },
    { name: "D", value: 25 },
  ];

  // Function to determine the color based on the value
  const getColorByValue = (value) => {
    if (value < 15) return "Blue"; // Blue
    else if (value < 20) return "green"; // Green
    else return "#Orange"; // Orange
  };
  return (
    <div>
      <div style={{ width: "100%", overflow: "visible !important" }}>
        {!rigName && (
          <div
            style={{
              height: "auto",
              marginTop: "25px",
              padding: isFullScreen ? "0px 15px 0px 15px" : "0px 30px 0px 15px",
            }}
            className="graph graph-content"
          >
            <div>
              <div className="d-flex justify-content-between">
                <p
                  style={{
                    color: "#c7c7c7",
                    fontSize: "14px",
                    borderBottom: "2px solid #c7c7c7",
                    width: "160px",
                    padding: "12px 16px",
                    textAlign: "center",
                  }}
                >
                  Summary{" "}
                </p>
                <div>
                  <ToolTipCore
                    title={isFullScreen ? "Exit Full Screen" : "Full Screen"}
                  >
                    <Button
                      size={"small"}
                      startIcon={
                        isFullScreen ? <HouseIcon /> : <FullscreenIcon />
                      }
                      onClick={() => {
                        toggleFullScreen();
                      }}
                      style={{ backgroundColor: "#242424", color: "#c7c7c7" }}
                    />
                  </ToolTipCore>
                  <ToolTipCore title="Refresh">
                    <IconButton
                      onClick={handleRefresh}
                      style={{ color: "#c7c7c7" }}
                    >
                      <RefreshIcon />
                    </IconButton>
                  </ToolTipCore>
                </div>
              </div>

              <div style={{ color: "#c7c7c7" }}>
                {allJobsData ? (
                  <>
                    {logs && well && rigsId && (
                      <>
                        <span>
                          <b>Start Time: </b>{" "}
                          {startTime ? `   ${startTime}` : "    -"}
                        </span>{" "}
                        <br />
                        <span>
                          <b>End Time: </b>
                          {endTime ? `   ${endTime}` : "    -"}
                        </span>
                        <br />
                        <span>
                          <b>Rig Name: </b>
                          {rigsId ? (
                            rigsId.length > 30 ? (
                              <span title={rigsId}>
                                {" "}
                                {rigsId.slice(0, 30)}...
                              </span>
                            ) : (
                              <span>{rigsId}</span>
                            )
                          ) : (
                            "-"
                          )}
                        </span>
                        <br />
                        <span>
                          <b>Well Name: </b>
                          {well ? (
                            well.length > 30 ? (
                              <span title={well}> {well.slice(0, 30)}...</span>
                            ) : (
                              <span>{well}</span>
                            )
                          ) : (
                            "-"
                          )}
                        </span>
                        <br />
                        <span>
                          <b>Log Name:</b>
                          {logs ? (
                            logs.length > 30 ? (
                              <span title={logs}> {logs.slice(0, 30)}...</span>
                            ) : (
                              <span>{logs}</span>
                            )
                          ) : (
                            "-"
                          )}
                        </span>
                        <br />
                        <div>
                          <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="flex-end"
                            spacing={1}
                          >
                            <Typography
                              onClick={() => setIsInverted(false)}
                              sx={{
                                color: isInverted ? "#888" : "#fff",
                                cursor: "pointer",
                                fontWeight: isInverted ? "normal" : "bold",
                              }}
                            >
                              Not Inverted
                            </Typography>
                            <Switch
                              checked={isInverted}
                              className="switchCase"
                              style={{ color: "#c7c7c7" }}
                              onClick={() => setIsInverted(!isInverted)}
                            />
                            <Typography
                              onClick={() => setIsInverted(true)}
                              sx={{
                                color: isInverted ? "#fff" : "#888",
                                cursor: "pointer",
                                fontWeight: isInverted ? "bold" : "normal",
                              }}
                            >
                              Inverted
                            </Typography>{" "}
                          </Stack>
                        </div>
                      </>
                    )}
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>

            {allJobsData ? (
              randomData && randomData.length > 0 ? (
                <>
                  <ResponsiveContainer
                    width={isFullScreen ? "100%" : "94%"}
                    height={350}
                    style={{
                      marginTop: "70px",
                      position: "absolute",
                      left: "-10px",
                    }}
                  >
                    <BarChart data={randomData}>
                      <XAxis
                        dataKey="name"
                        style={{ fontSize: "11px" }}
                        angle={-90}
                        dy={35}
                        height={100}
                      />
                      <YAxis />
                      <Bar
                        dataKey="value"
                        cursor="pointer"
                        onClick={(data) => handleLogBar(data.name)}
                      >
                        <LabelList
                          className="labelBar"
                          position="insideCenter"
                          fill="black"
                          style={{ fontSize: "10px" }}
                          dataKey="value"
                          angle={-90}
                          formatter={(value) =>
                            `${parseFloat(value).toFixed(2)}%`
                          }
                        />
                        {randomData.map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={renderColor(entry.value)}
                          />
                        ))}
                      </Bar>
                      <Tooltip
                        cursor={{ fill: "transparent" }}
                        formatter={(value) =>
                          `${parseFloat(value).toFixed(2)} %`
                        }
                        contentStyle={{
                          backgroundColor: "#2b2b2b",
                          border: "1px solid #555",
                          color: "#c7c7c7",
                          fontSize: "12px",
                        }}
                        itemStyle={{
                          color: "#c7c7c7",
                          fontSize: "12px",
                        }}
                        labelStyle={{
                          color: "#c7c7c7",
                          fontWeight: "bold",
                        }}
                      />
                      <Brush
                        dataKey="name"
                        height={20}
                        // stroke="rgb(40, 102, 133)"
                        stroke="#c7c7c7"
                        fill="#2b2b2b"
                      />
                      {CommonLegend}
                    </BarChart>
                  </ResponsiveContainer>
                </>
              ) : (
                <div className="no-data-message">
                  <span style={{ fontWeight: 700 }}>
                    Data is not availables
                  </span>
                </div>
              )
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
};

export default DataQuality;
